import { render, staticRenderFns } from "./PaymentMethodeForm.vue?vue&type=template&id=6af52674&"
import script from "./PaymentMethodeForm.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports